import React from "react";
import { Route, Switch } from "react-router-dom";
import { RouteAuthorize } from "./routes/RouteAuthorize";

export const OAUTH_ROOT_PATH = "/oauth";
export const OAUTH_AUTHORIZE_PATH = `${OAUTH_ROOT_PATH}/authorize`;

export const OAuthIndex: React.FC = () => {
  return (
    <Switch>
      <Route path={OAUTH_AUTHORIZE_PATH} component={RouteAuthorize} exact />
    </Switch>
  );
};

export { oauthService } from "./services/oauthService";
export type { IOAuthAuthorizeParams } from "./types";
